// Cores das tags de contato (SA-1051). Light vem do preview aprovado;
// dark gerado mirando contraste AA. Centralizado aqui (tokens) para os
// componentes não hardcodarem hex.

export const TAG_COLORS = [
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "blue",
  "violet",
  "gray",
] as const;

export type TagColor = (typeof TAG_COLORS)[number];

export type TagColorPair = { bg: string; fg: string };

export const TAG_COLOR_TOKENS: Record<
  TagColor,
  { light: TagColorPair; dark: TagColorPair }
> = {
  red: {
    light: { bg: "#FDE7E9", fg: "#A8202B" },
    dark: { bg: "#3A1D20", fg: "#F4A0A6" },
  },
  orange: {
    light: { bg: "#FFEFD9", fg: "#9A5A00" },
    dark: { bg: "#3A2A14", fg: "#F0B870" },
  },
  yellow: {
    light: { bg: "#FFF6C7", fg: "#7A5800" },
    dark: { bg: "#33300F", fg: "#E6D06A" },
  },
  green: {
    light: { bg: "#E1F4E5", fg: "#1E6F38" },
    dark: { bg: "#16301F", fg: "#7FD49A" },
  },
  teal: {
    light: { bg: "#D6F1EE", fg: "#0F6F66" },
    dark: { bg: "#10302D", fg: "#6FD0C6" },
  },
  blue: {
    light: { bg: "#E0EAFD", fg: "#1F4DAA" },
    dark: { bg: "#172339", fg: "#8FB2F0" },
  },
  violet: {
    light: { bg: "#EBE3FF", fg: "#4D26BF" },
    dark: { bg: "#251A3D", fg: "#B9A3F5" },
  },
  gray: {
    light: { bg: "#E9ECEF", fg: "#495057" },
    dark: { bg: "#2A2941", fg: "#AFB3C0" },
  },
};

/**
 * Par de cores da tag no esquema atual. Cor ausente ou fora do enum (tag gravada
 * por fora do app) cai no cinza: uma tag ruim não pode derrubar a tela inteira.
 */
export function getTagColorPair(
  color: string | null | undefined,
  scheme: "light" | "dark"
): TagColorPair {
  const tokens = TAG_COLOR_TOKENS[color as TagColor] ?? TAG_COLOR_TOKENS.gray;
  return tokens[scheme];
}
